import ShopArticleTaxHistoryListResultModelBase from '../_generated/modelBases/shop-article-tax-history-list-result-model-base';

export default class ShopArticleTaxHistoryListResultModel extends ShopArticleTaxHistoryListResultModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
